import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./page/Home";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:url" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
